module.exports = __webpack_public_path__ + "img/posts.cb9bb309.svg";